import { DatePipe, registerLocaleData } from '@angular/common';
import localeNL from '@angular/common/locales/nl';
import { LOCALE_ID, NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { HttpModule } from '@angular/http';
import {
  MatButtonModule,
  MatInputModule,
  MatDatepickerModule,
  MatIconModule,
  MatNativeDateModule,
  MatAutocompleteModule
} from '@angular/material';
import { MatSelectModule } from '@angular/material/select';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import 'hammerjs';
import { AppComponent } from './app.component';
import { FilterByChurchPipe } from './filter-by-church.pipe';
import { HistoryListComponent } from './history-list/history-list.component';
import { LectureListItemComponent } from './lecture-list-item/lecture-list-item.component';
import { OrderByTimePipe } from './order-by-time.pipe';
import { PrayerTopicsComponent } from './prayer-topics/prayer-topics.component';
import { CurchService } from './providers/church.service';
import { LecturesService } from './providers/lectures.service';
import { OrganistService } from './providers/organist.service';
import { PrayerTopicsService } from './providers/prayer-topics.service';
import { ScripturesService } from './providers/scriptures.service';
import { TimeService } from './providers/time.service';
import { VicarService } from './providers/vicar.service';
import { RightPadPipe } from './right-pad.pipe';
import { ScripturesListComponent } from './scriptures-list/scriptures-list.component';
import { UpcomingListComponent } from './upcoming-list/upcoming-list.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';



registerLocaleData( localeNL );

@NgModule({
  declarations: [
    AppComponent,
    LectureListItemComponent,
    HistoryListComponent,
    OrderByTimePipe,
    FilterByChurchPipe,
    RightPadPipe,
    UpcomingListComponent,
    ScripturesListComponent,
    PrayerTopicsComponent
  ],
  imports: [
    BrowserModule,
    HttpModule,
    BrowserAnimationsModule,
    MatAutocompleteModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatButtonModule,
    MatIconModule,
    MatSelectModule,
    FlexLayoutModule,
    ReactiveFormsModule,
    FormsModule,
    MatInputModule,
    NgbModule.forRoot()
  ],
  providers: [
    DatePipe,
    LecturesService,
    VicarService,
    CurchService,
    OrganistService,
    TimeService,
    ScripturesService,
    PrayerTopicsService,
    { provide: LOCALE_ID, useValue: 'nl' }
  ],
  bootstrap: [ AppComponent ],
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts